<template>
  <div class="home-view">
    <!-- Kategorifilter (visas alltid eller när man inte gör en specifik sökning) -->
    <CategoryFilter
      :categories="categories"
      :active-category="activeCategory"
      :counts="categoryCounts"
      @select-category="selectCategory"
    />

    <!-- Receptlistan -->
    <RecipeGrid
      :recipes="filteredRecipes"
      :title="gridTitle"
      @select-recipe="selectRecipe"
      @reset-filters="resetFilters"
    />
  </div>
</template>

<script>
import CategoryFilter from '../components/CategoryFilter.vue'
import RecipeGrid from '../components/RecipeGrid.vue'
import { categories } from '../data/categories'
import { recipes } from '../data/recipes'
import { updateSEOForRecipe } from '../utils/seo'

export default {
  name: 'HomeView',
  components: {
    CategoryFilter,
    RecipeGrid
  },
  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      categories,
      recipes
    }
  },
  computed: {
    activeCategory() {
      return this.$route.params.category || 'alla'
    },
    categoryCounts() {
      const counts = {
        alla: this.recipes.length
      }
      this.categories.forEach(cat => {
        if (cat.id !== 'alla') {
          counts[cat.id] = this.recipes.filter(r => r.category === cat.id).length
        }
      })
      return counts
    },
    filteredRecipes() {
      let list = this.recipes

      // Filtrera på aktiv kategori från URL (/kategori/:category)
      if (this.activeCategory && this.activeCategory !== 'alla') {
        list = list.filter(r => r.category === this.activeCategory)
      }

      // Filtrera på fritextsökning
      const query = (this.searchQuery || '').trim().toLowerCase()
      if (query) {
        list = list.filter(r => {
          const matchTitle = r.title.toLowerCase().includes(query)
          const matchDesc = r.description.toLowerCase().includes(query)
          const matchCategory = r.categoryName && r.categoryName.toLowerCase().includes(query)
          const matchIngredient = r.ingredients.some(ing =>
            ing.name.toLowerCase().includes(query)
          )
          return matchTitle || matchDesc || matchCategory || matchIngredient
        })
      }

      return list
    },
    gridTitle() {
      if (this.searchQuery.trim()) {
        return `Sökresultat för "${this.searchQuery}"`
      }
      const activeCat = this.categories.find(c => c.id === this.activeCategory)
      return activeCat ? activeCat.name : 'Alla recept'
    }
  },
  watch: {
    activeCategory: {
      immediate: true,
      handler(newCat) {
        if (newCat && newCat !== 'alla') {
          const catObj = this.categories.find(c => c.id === newCat)
          const catName = catObj ? catObj.name : newCat
          document.title = `${catName} – Receptbanken`
        } else {
          updateSEOForRecipe(null)
        }
      }
    }
  },
  methods: {
    selectCategory(catId) {
      if (catId === 'alla') {
        this.$router.push('/')
      } else {
        this.$router.push(`/kategori/${catId}`)
      }
    },
    selectRecipe(recipeId) {
      this.$router.push(`/recept/${recipeId}`)
    },
    resetFilters() {
      this.$emit('reset-search')
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.home-view {
  width: 100%;
}
</style>
